import React, { MouseEvent } from "react"

import { useLayerPopupContext } from "@shared/contexts"

function InstallChrome() {
  const { close } = useLayerPopupContext()

  return (
    <article
      className="popup"
      style={{ width: "430px", margin: "-130px 0 0 -215px" }}
    >
      <div className="titB">
        <h1>크롬 설치 공지</h1>
        <a
          href="#!"
          title="닫기"
          onClick={(e: MouseEvent) => {
            e.preventDefault()
            close()
          }}
        >
          닫기
        </a>
      </div>
      <div className="txtB chromeB">
        <strong>
          원활한 방송시청을 위해
          <br />
          크롬(Chrome) 브라우저 설치 후 이용해주세요.
        </strong>
        <div className="linkB">
          <p>크롬 다운로드 링크</p>
          <a href="https://www.google.com/intl/ko/chrome">
            https://www.google.com/intl/ko/chrome
          </a>
        </div>
        <em>
          ※ Intetnet Explorer 브라우저에서는 플레이어가 정상적으로 동작하지 않을
          수<br />
          있습니다.
        </em>
      </div>
    </article>
  )
}

export default InstallChrome
